export const PERF_BUDGETS = {
  interactionLatencyMs: 100,
  frameBudgetMs: 16,
  maxPrimitivesPerViewport: 200_000,
  maxMemoryMB: 512
};
